<template>
  <div>
    <span>
      <vs-button
        color="success"
        type="gradient"
        icon="edit"
        radius
        @click="guncelle()"
        ></vs-button
      >
    </span>
  </div>
</template>
<script>
export default {
  methods: {
    guncelle() {
      this.$root.$emit("setGuncellenecekKullanici", this.params.data);
    },
  },
};
</script>